import { Component, Input } from '@angular/core';
import { GlobalsSingleton } from '../../../app/core/GlobalsSingleton';
import { eGENA_Checkliste } from '../../../visionet/Checkliste';


@Component({
	selector: 'Reanimation',
	templateUrl: 'Reanimation.html'
})

export class ReanimationSucheComponent {

	@Input()
	curSearchResultChecklists: eGENA_Checkliste[]
	@Input()
	ausgewaehlterPatiententyp: string;
	@Input()
	activeSearch: string = ''



	constructor(public globals: GlobalsSingleton) {
	}




	isTablettOrPc() : boolean {
		return !this.globals.isPhone();
	}

}



// WEBPACK FOOTER //
// ./src/components/Suche/Reanimation/Reanimation.ts